<template>
    <label class="block max-w-4xl">
        <input
            v-if="!disabled"
            class="mr-2 leading-tight form-checkbox"
            type="checkbox"
            :name="name"
            @change="(e) => $emit('change', e.target.checked)"
            :checked="checked"
        />
        <svg v-if="disabled && checked" class="inline" style="filter: opacity(25%);transform: scale(0.7);margin: -4px 4px -4px -4px;" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path d="M0 0v24h24v-24h-24zm10.041 17l-4.5-4.319 1.395-1.435 3.08 2.937 7.021-7.183 1.422 1.409-8.418 8.591z"/>
        </svg>
        <svg v-if="disabled && !checked" class="inline" style="filter: opacity(25%);transform: scale(0.7);margin: -4px 4px -4px -4px;" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path d="M22 2v20h-20v-20h20zm2-2h-24v24h24v-24z"/>
        </svg>
        <span :class="labelClass">{{ label }}</span>
        <error :error="error" />
    </label>
</template>

<script>
export default {
    name: "InputCheckbox",
    model: {
        prop: 'checked',
        event: 'change',
    },
    props: {
        name: String,
        label: String,
        labelClass: {
            type: String,
            required: false,
            default: "text-gray-700",
        },
        checked: {
            type: [Boolean,Number],
            default: false,
        },
        error: {
            type: String,
            required: false,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
};
</script>
